<div class="line-header">
	<div class="cancel-block" (click)="cancelButton()">
		Cancel
	</div>
</div>

<div class="items-block">
	<div class="clas-serv-item" *ngFor="let item of items" (click)="chooseItem(item)" matRipple>
		{{item.fullyQualifiedName}}
	</div>
</div>